module.exports = __webpack_public_path__ + "img/abcToSymbols.ac6306e9.png";